import React, { useEffect } from "react";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ReactComponent as SuccessIcon } from "../../../assets/images/NoticeSuccessIcon.svg";
import { ReactComponent as ErrorIcon } from "../../../assets/images/NoticeErrorIcon.svg";
import { ReactComponent as WarningIcon } from "../../../assets/images/NoticeWarningIcon.svg";
import { ReactComponent as InfoIcon } from "../../../assets/images/NoticeInfoIcon.svg";
import {
  selectMessage,
  setMessage,
} from "../../../store/wizardCreate/wizardCreateSlice";
import {
  getViewportCap,
  measureNoticeWidth,
} from "../../../modules/RefactoredWizard/utils/notification-width";
import { useShopifyApp } from "../../../hooks/useShopifyApp";

import { Container } from "./styles";

const typeConfig = {
  error: {
    style: {
      border: "1px solid #FCA5A5",
      background: "#FEF3F2",
    },
    icon: <ErrorIcon />,
  },
  warning: {
    style: {
      border: "1px solid #FDB022",
      background: "#FFFAEB",
    },
    icon: <WarningIcon />,
  },
  success: {
    style: {
      border: "1px solid #148757",
      background: "#ECFDF3",
    },
    icon: <SuccessIcon />,
  },
  info: {
    style: {
      border: "1px solid #00AEEF",
      background: "#F1FCFF",
    },
    icon: <InfoIcon />,
  },
  "shopify-success": {
    style: {
      border: "1px solid #1a1a1a",
      background: "#1a1a1a",
    },
    icon: null,
  },
  "shopify-warning": {
    style: {
      border: "1px solid #1a1a1a",
      background: "#1a1a1a",
    },
    icon: null,
  },
  "shopify-error": {
    style: {
      border: "1px solid #C70A24",
      background: "#C70A24",
    },
    icon: <InfoCircleOutlined />,
  },
};

const Message = () => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const current = useSelector(selectMessage);
  const isShopifyApp = useShopifyApp();

  const openNotificationWithIcon = (type) => {
    const config = typeConfig[type];
    const measuredWidth = measureNoticeWidth(current?.message);
    const viewportCap = getViewportCap();
    const finalWidth = Math.min(measuredWidth, viewportCap);

    api.open({
      className: `${type}-notification custom-notification`,
      message: current?.message,
      placement: "bottom",
      duration: 3,
      onClose: () => dispatch(setMessage(null)),
      style: {
        ...config.style,
        width: finalWidth,
        borderRadius: 8,
        padding: "12px",
        maxWidth: viewportCap,
      },
      icon: config.icon,
    });
  };

  useEffect(() => {
    if (!current?.message) {
      api.destroy();
    } else {
      openNotificationWithIcon(
        isShopifyApp ? `shopify-${current?.type}` : current?.type,
      );
    }
  }, [current?.message]);

  useEffect(() => {
    api.destroy();
  }, []);

  return <Container>{contextHolder}</Container>;
};

export default Message;
